export default __webpack_public_path__ + "static/media/main_s.c6071c15.png";